import { AgeJunctureComponent } from "./age-juncture/age-juncture.component";
import { OfferJunctureComponent } from "./offer-juncture/offer-juncture.component";
import { DropdownFrameComponent } from "./dropdown-frame/dropdown-frame.component";
import { FamilyJunctureComponent } from "./family-juncture/family-juncture.component";
import { UserdataJunctureComponent } from "./userdata-juncture/userdata-juncture.component";
import { ContactinfoJunctureComponent } from "./contactinfo-juncture/contactinfo-juncture.component";
import { SocsecurityJunctureComponent } from "./socsecurity-juncture/socsecurity-juncture.component";
//import { CaptchaJunctureComponent } from "./captcha-juncture/captcha-juncture.component";
import { FinalpaymentJunctureComponent } from "./finalpayment-juncture/finalpayment-juncture.component";


export const components: any[] = [FinalpaymentJunctureComponent, SocsecurityJunctureComponent, ContactinfoJunctureComponent, UserdataJunctureComponent, FamilyJunctureComponent, AgeJunctureComponent, OfferJunctureComponent, DropdownFrameComponent]

export * from "./finalpayment-juncture/finalpayment-juncture.component";
//export * from "./captcha-juncture/captcha-juncture.component";
export * from "./socsecurity-juncture/socsecurity-juncture.component";
export * from "./contactinfo-juncture/contactinfo-juncture.component";
export * from "./userdata-juncture/userdata-juncture.component";
export * from "./family-juncture/family-juncture.component";
export * from "./age-juncture/age-juncture.component";
export * from "./offer-juncture/offer-juncture.component";
export * from "./dropdown-frame/dropdown-frame.component";